<template>
  <div class="text-base md:text-lg">
    <HeroSmall :data="page" />

    <Breadcrumbs />

    <div class="bg-amber-100 pt-16 md:pt-28">
      <LeadText :lead="page.lead" />
    </div>

    <BlogOverview />

    <ComponentsLoader v-if="page.components" :components="page.components" />
  </div>
</template>

<script setup>
defineProps({
  page: { type: Object, required: true },
})
</script>
